/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Import_Dashboard_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic AD Import" |
*
* @param {Ad_Import_Dashboard_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_dashboard_title = /** @type {((inputs?: Ad_Import_Dashboard_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_Dashboard_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation automatique des annonces")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatischer AD-Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione automatica di AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматический импорт рекламы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación automática de AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动 AD 导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動広告インポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित विज्ञापन आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação automática de anúncios")
	return /** @type {LocalizedString} */ ("Automatic AD Import")
});